module.exports = __webpack_public_path__ + "img/camping_tent_stroke.a33f1116.svg";